import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const updateTeacherFavoriteStudio = createAsyncThunk<void, { id: string }, { extra: Partial<Dependencies> }>(
  "teachers/updateTeacherFavoriteStudio",
  async (favoriteStudio: { id: string }, { extra: { teacherRepository } }) => {
    await teacherRepository!.updateFavoriteStudio(favoriteStudio);
  },
);

export const resetUpdateTeacherFavoriteStudio = createAction("teachers/resetUpdateTeacherFavoriteStudio");
